/**
 * Experiment to persist quick add on the search tile.
 * https:www.notion.so/faire/Default-quick-add-on-the-discovery-tile-web-1292efb5c25a80279733f237f42511b6?pvs=4
 */ export var PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029 = 'PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029';
